import { sub } from "date-fns";
import Blue from "~/core";

new Blue({
	name: 'Header Nav Menu',
  selector: ".header",
  setup(header) {
		const menuTrigger = header.querySelector(".header__trigger--menu");
		const searchTrigger = header.querySelector(".header__trigger--search");
		const modalCloseBtn = header.querySelector(".header__trigger--close");
		const input = header.querySelector("input#header-search");
		const submit = header.querySelector("button.header__search-submit");
		const nav = header.querySelector("nav.header__nav");
		const secondaryTriggers = [...header.querySelectorAll(".header__primary-trigger")];
		const secondaryLists = [...header.querySelectorAll(".header__secondary-list")];
		const secondaryBackBtns = [...header.querySelectorAll(".header__secondary-back")];

		if (window.innerWidth > 768 && !!secondaryLists.length) {
			let tallest = 0;
			secondaryLists.forEach(list => {
				if (list.scrollHeight > tallest) tallest = list.scrollHeight;
			});
			nav.style.minHeight = tallest + "px";
		}

		const openModal = modalType => {
			header.classList.add(modalType + "-open");
			header.classList.add("modal-open");
			this.$scrollLock.lock(document.querySelector(".header__modal-backdrop"));
			if (modalType === "search") {
				header.classList.remove("menu-open");
				setTimeout(() => {input.focus();}, 800);
			} else {
				header.classList.remove("search-open");
				setTimeout(() => {modalCloseBtn.focus();}, 800);
			}
		}

		const closeModal = () => {
			let modalType = header.matches(".search-open") ? "search" : "menu";
			header.classList.remove("modal-open");
			header.classList.remove(modalType + "-open");
			this.$scrollLock.unlock(document.querySelector(".header__modal-backdrop"));
			header.querySelector(".header__trigger--" + modalType).focus();
		}

		const openSecondaryNav = e => {
			let parentItem = e.target.closest(".header__primary-item");
			header.classList.add("secondary-open");
			parentItem.classList.add("is-open");
			parentItem.querySelector(".header__secondary-back").focus();
		}

		const closeSecondaryNav = () => {
			let parentItem = header.querySelector(".header__primary-item.is-open");
			if (!!parentItem) {
				header.classList.remove("secondary-open");
				parentItem.classList.remove("is-open");
				parentItem.querySelector(".header__primary-trigger").focus();
			}
		}

		this.$addEvents(menuTrigger, "click.prevent", () => {openModal('menu')});
		this.$addEvents(searchTrigger, "click.prevent", () => {openModal('search')});
		this.$addEvents(modalCloseBtn, "click.prevent", () => {
			if (!!header.querySelector(".header__primary-item")) closeSecondaryNav();
			closeModal();
		});

		secondaryTriggers.forEach(trigger => {
			this.$addEvents(trigger, "click.prevent", e => {openSecondaryNav(e)});
		});
		secondaryBackBtns.forEach(btn => {
			this.$addEvents(btn, "click.prevent", () => {closeSecondaryNav()});
		});
		this.$addEvents(document, "keydown", e => {
			if (e.code == "Escape" && header.matches(".modal-open")) {closeModal()};
		})

		// TAB TRAPPING
		this.$addEvents(submit, "tab.prevent", () => {modalCloseBtn.focus()});
		this.$addEvents(searchTrigger, "tab.shift", (e) => {
			if (header.matches(".menu-open")) e.preventDefault()
		});
		this.$addEvents(modalCloseBtn, "tab.shift", (e) => {
			if (header.matches(".search-open")) e.preventDefault()
		});
		[...header.querySelectorAll("nav li.header__secondary-item:last-child a[href], a.header__util-link")].forEach(lastLink => {
			this.$addEvents(lastLink, "tab.prevent", () => {searchTrigger.focus()});
		});
  }
});

new Blue({
	name: 'Header Search Submit',
  selector: "form.header__search",
  setup(form) {
		const path = form.getAttribute("data-search-path") || "/search";
		const input = form.querySelector("input.header__search-input")

		this.$addEvents(form, "submit", e => {
			e.preventDefault();
			let val = input.value.trim();
			if (val == "") {
				input.classList.add("is-errored");
				input.value = "";
				input.setAttribute("placeholder", "Please enter a search term")
				return;
			}
			let queryString = "?query=" + encodeURIComponent(val);
			window.location = path + queryString;
		});

		this.$addEvents(input, "input", e => {
			if (!!input.value.trim()) input.classList.remove("is-errored");
		});
  }
});

new Blue({
	name: 'Header Search Autocomplete',
  selector: "form.header__search[data-autocomplete-endpoint]",
  setup(form) {
		const autoCompleteText = async () => {
			let typingTimer = null;
			let doneTypingInterval = 500;
			let minRequiredCharacters = 3;
			let url = form?.getAttribute("data-autocomplete-endpoint");
			let searchPath = form?.getAttribute("data-search-path");
			const inp = form?.querySelector(".header__search-input");
			const submit = form?.querySelector(".header__search-submit");

			const returnSuggestionElements = () => {
				return [...form.querySelectorAll('.header__autocomplete-link:not(.header__autocomplete-none)')];
			}

			const highlightNextSuggestion = (e) => {
				e.preventDefault();
				const inputIsFocused = inp.matches(':focus');
				let highlightedElementIndex;
				let suggestionElements = returnSuggestionElements();
	
				if (inputIsFocused) {
					suggestionElements[0]?.focus();
				} else {
					highlightedElementIndex = suggestionElements.findIndex(el =>
						el.matches(':focus')
					);
					if (highlightedElementIndex < suggestionElements.length - 1) {
						suggestionElements[highlightedElementIndex + 1]?.focus();
					} else {
						suggestionElements[0]?.focus();
					}
				}
			}
			const highlightPreviousSuggestion = e => {
				e.preventDefault();
				const inputIsFocused = inp.matches(':focus');
				let highlightedElementIndex;
				let suggestionElements = returnSuggestionElements();
	
				if (inputIsFocused) {
					suggestionElements.at(-1)?.focus();
				} else {
					highlightedElementIndex = suggestionElements.findIndex(el =>
						el.matches(':focus')
					);
					if (highlightedElementIndex > 0) {
						suggestionElements[highlightedElementIndex - 1]?.focus();
					} else {
						suggestionElements.at(-1)?.focus();
					}
				}
			}
	
			if (!!inp && !!url) {
				inp.addEventListener("input", function (e) {
		
					clearTimeout(typingTimer);
					typingTimer = setTimeout(doneTyping, doneTypingInterval);
		
					closeAllLists();
		
					doneTyping(this.value, this.parentNode);
		
					inp.onfocus = function () {
						if (inp.value) {
							doneTyping(this.value, this.parentNode);
						}
					}
				});
				const closeAllLists = (elmnt) => {
					let x = document.getElementsByClassName("header__autocomplete");
					for (var i = 0; i < x.length; i++) {
						if (elmnt != x[i] && elmnt != inp) {
							x[i].parentNode.removeChild(x[i]);
						}
					}
				}
				document.addEventListener("click", function (e) {
					if (!e.target.closest(".header__search")) closeAllLists(e.target);
				});
				const disableAutocomplete = true;
				const doneTyping = async (val, parentNode) => {
					if (!val || val.length < minRequiredCharacters) {
						return;
					}
					let acWrapper, acItem, i;
					if (!val) { return false; }
					acWrapper = document.createElement("div");
					acWrapper.classList.add("header__autocomplete");
					parentNode.appendChild(acWrapper);
		
					if (val && val.trim()) {
						val = val.trim();
		
						const headers = {
							'Content-Type': 'application/json'
						}
						var dataToSend = { term: val };
						// rewrite axios post below using the fetch API to avoid axios dependency
						await fetch(url, {
							method: 'POST',
							headers: headers,
							body: JSON.stringify(dataToSend)
						}).then((response) => {
							return response.json();
						}).then((items) => {
							if (items.length <= 0 || (items.length == 1 && items[0] == null)) {
								if(!disableAutocomplete){
									acItem = document.createElement("div");
									acItem.classList.add("header__autocomplete-none");
									acItem.innerHTML = "<b>No results found</b>";
									acWrapper.appendChild(acItem);
								}
							} else {
								items.forEach((item, index) => {
									if (item == null) return;
									acItem = document.createElement("a");
									acItem.setAttribute("href", `${searchPath}?query=${item.searchText}`);
									acItem.setAttribute("aria-label", `Search website for ${item.searchText}`);
									acItem.classList.add("header__autocomplete-link");
									acItem.innerHTML = item.textWithHightlights;
									acWrapper.appendChild(acItem);
									this.$addEvents(acItem, "keydown", e => {
										if (e.key === "ArrowDown") {
											highlightNextSuggestion(e);
											return;
										}
										if (e.key === "ArrowUp") {
											highlightPreviousSuggestion(e);
											return;
										}
									});
									if (index == items.length - 1) {
										this.$addEvents(acItem, "keydown", e => {
											if (e.key === "Tab") {
												e.preventDefault();
												submit.focus();
											}
										});
									}
								});
							}
						}).catch((error) => {
							console.error('Error:', error);
						});
					}
				}
			}
			this.$addEvents(inp, "keydown", (e) => {
				if (e.key === "Tab" && !!form.querySelector(".header__autocomplete-link:first-of-type")) {
					e.preventDefault();
					form.querySelector(".header__autocomplete-link:first-of-type").focus();
				}
				if (e.key === "ArrowDown") {
					highlightNextSuggestion(e);
				}
			});
		};
		autoCompleteText();
  }
});
